import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../auth/services/auth.service";
import {Subscription } from "rxjs";


export const authGuardActivate : () => false | Subscription = ()=>{
  const authService = inject(AuthService);
  const router = inject(Router)

  if(!localStorage.getItem('token')) {
    router.navigate(['/auth/login'])
    return false;
  }
  const token = localStorage.getItem('token');
  return authService.checkAutentication(token!)
    .subscribe({
      next: (response)=> {
      },
      error: (err)=> {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        router.navigate(['/auth/login'])
        return false;
      }
    })
}
